<div class="backIcon">
    <mat-icon class="close-icon" [routerLink]="['/private-space/view-valuation-requests']"
      >close</mat-icon
    >
    <mat-icon class="create-icon" (click)="onEditValuationRequest()" >create</mat-icon>
  </div>
  
  <div class="text-center mat-header">View a Valuation Request</div>
  <div class="form-group col-sm-12 text-center" *ngIf="isLoading">
    <img
      class="loader"
      src="../../assets/images/loader.gif"
      width="60px"
      alt=""
    />
  </div>
  <mat-card-content *ngIf="!isLoading">
    <form
    [formGroup]="editValuationRequestForm" (ngSubmit)="onSubmitEditForm()"
    class="row g-3 needs-validation"
  >
  <div class="form-group col-sm-12">
    <label  for="searchProperty">Property</label>

    <input readOnly class="form-control"  id="searchProperty"  formControlName="propertyName" type="text" value="" />

  </div>
    <div class="form-group col-sm-12">
      <label for="description">Description</label>
      <textarea readOnly
        class="form-control"
        id="description"
        formControlName="description"
        required
        type="text"
      ></textarea>
      <span
        class="validation-error"
        *ngIf="
          (customStylesValidated ||
            editValuationRequestForm.controls.description.touched) &&
          editValuationRequestForm.controls.description.errors?.required
        "
        >Please fill</span
      >
    </div>
    <div class="form-group col-sm-12">
      <label for="agencyName">Agency Name</label>
      <input readOnly
        class="form-control"
        id="agencyName"
        formControlName="agencyName"
        required
        type="text"
      />
      <span
        class="validation-error"
        *ngIf="
          (customStylesValidated ||
            editValuationRequestForm.controls.agencyName.touched) &&
          editValuationRequestForm.controls.agencyName.errors?.required
        "
        >Please fill</span
      >
    </div>
    <div class="form-group col-sm-12">
        <label for="agencyName">Status</label>
        <input
          class="form-control"
          id="status"
          formControlName="status"
          readonly
          type="text"
        />
    </div>
    
    <!-- <p-messages [value]="msgs"></p-messages> -->
    <div class="form-group col-sm-12 text-center" *ngIf="isLoading">
      <img
        class="loader"
        src="../../assets/images/loader.gif"
        width="60px"
        alt=""
      />
    </div>
  </form>
  </mat-card-content>